/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import toastr from '@/lib/notifications';
import $ from 'jquery';
import _ from 'underscore';
import store from '../state/store';

store.on('tutor_selection:create', function(params) {
  if (params == null) { params = {}; }
  const pending_tutor_proposals = _.select(params.tutor_proposals, tutor_proposal => !_.isFinite(tutor_proposal.id));

  const parsedParams = {
    tutoring_job_id: params.tutoring_job_id,
    tutor_proposals: _.map(pending_tutor_proposals, function(tutor_proposal) {
      return {
        tutor_id: tutor_proposal.tutor.id,
        tutoring_job_position_id: tutor_proposal.tutoring_job_position.id,
        motivation: tutor_proposal.motivation
      }
    }),
    notify_via_mail: params.notify_via_mail,
    notify_via_sms: params.notify_via_sms
  };

  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/tutor_selections`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(parsedParams),
    success: (data) => {
      toastr.success('Tutors proposed!');
      store.get().set({tutor_proposals: data.tutor_proposals});

      const { tutor_results } = store.get();
      const tutor_result = _.first(_.select(tutor_results, tutor_result => tutor_result.tutor.id ===params.tutor_id));

      if (tutor_result) {
        return tutor_result.set({job_candidate: data});
      }
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

store.on('tutoring_job:tutor_selection:accept', function(params) {
  if (params == null) { params = {}; }
  return $.ajax({
    url: `/api/sales/tutoring_jobs/${params.tutoring_job_id}/tutor_selections/accept`,
    type: 'POST',
    dataType: 'json',
    contentType: 'application/json',
    data: JSON.stringify(params),
    success: (data) => {
      return store.emit('tutoring_jobs:show', params.tutoring_job_id);
    },
    error: (data) => {
      return toastr.error(__guard__(data != null ? data.responseJSON : undefined, x => x.custom_error_message) || 'something went wrong');
    }
  });
});

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}